<div class="container">
  <div class="row">
    <div class="col-md-6 order-sm-12 m-t-40 m-b-10">
      <h2>{{ 'login.login.title' | translate }}</h2>
      <form name="form" (ngSubmit)="f.form.valid && login()" #f="ngForm" novalidate>
        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !email.valid }">
          <label for="email">{{ 'login.login.email' | translate }}</label>
          <input type="text" class="form-control" name="email" [(ngModel)]="model.email" #email="ngModel" required />
          @if (f.submitted && !email.valid) {
            <div class="help-block">{{ 'login.login.emailhelp' | translate }}</div>
          }
        </div>
        <div class="form-group" [ngClass]="{ 'has-error': f.submitted && !password.valid }">
          <label for="password">{{ 'login.login.password' | translate }}</label>
          <input type="password" class="form-control" name="password" [(ngModel)]="model.password" #password="ngModel" required />
          @if (f.submitted && !password.valid) {
            <div class="help-block">{{ 'login.login.passwordhelp' | translate }}</div>
          }
        </div>
        <div class="form-group">
          <button [disabled]="loading" class="btn btn-primary">{{ 'login.login.button' | translate }}</button>
          @if (loading) {
<img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
}
                </div>
                @if (error) {
<div class="alert alert-danger">{{error}}</div>
}
            </form>
            <div class="form-group">
              <div class="col-xs-10 col-xs-offset-3 text-left">
                <a [routerLink]="['/forgot/.']">{{ 'login.login.forgot' | translate }}</a>
              </div>
            </div>
        </div>
        <div class="col-md-6 order-sm-1 m-t-40 m-b-10">
            <h2>{{ 'login.create.title' | translate }}</h2>
            <p>{{ 'login.create.description' | translate }}</p>
            <button class="btn btn-primary" [routerLink]="['/register/.']">{{ 'history.account.register' | translate }}</button>
        </div>

    </div>
</div>